import { ClientSaasOpsIntegrations } from 'application/Shared/Components/Client/SaasOps/ClientSaasOpsIntegrations';

/*  React  */
import React from 'react';
import { useParams } from 'react-router';

export const ClientIntegrations = (): JSX.Element => {
    const { clientId } = useParams();

    return <ClientSaasOpsIntegrations clientId={clientId} />;
};
